/* Review renderer copied from the current v4 block, scoped to the long LP. */
(() => {
  function init() {
    document.querySelectorAll('[data-v5-customer-reviews]').forEach(root=>{
      if(root.dataset.ready)return;root.dataset.ready='true';
      const snippets=[
  [
    "A calmer routine for our multi-cat home",
    "We have four cats, and introducing a new kitten changed the mood in our living room. We added VelaHush to their usual routine while keeping separate food bowls and resting spots. The cats still have their own personalities, but sharing the room feels less hectic now. Setup was straightforward, and we are continuing to give them time to adjust.",
    "kitten",
    "Emma M",
    "long"
  ],
  [
    "Simple to set up",
    "Easy to assemble and no added fragrance. It fits neatly into our living-room routine.",
    "kitten",
    "Nicole K",
    "short"
  ],
  [
    "Easy to fit into our daily routine",
    "The diffuser was easy to set up, and I like that there is no added fragrance. Our cats spend time in two separate rooms, so we chose a diffuser for each room instead of expecting one to cover the whole house. It fits neatly into an uncovered wall outlet. I would recommend checking your room layout before choosing a kit.",
    "kitten",
    "Jeanette L",
    "long"
  ],
  [
    "One for each room",
    "We chose two diffusers for two rooms. The kit selection was easy to understand.",
    "kitten",
    "Daniel R",
    "short"
  ],
  [
    "Taking it slowly",
    "Our kitten is still cautious, but we are keeping her routine steady and giving her time.",
    "hiding",
    "Rachel B",
    "short"
  ],
  [
    "Helpful while introducing a new kitten",
    "Bringing home a kitten meant giving our older cat more space and a predictable routine. We placed VelaHush in the room they use most and continued with slow, supervised introductions. They are starting to spend more time in the same area without us rushing them. It has been a simple addition to the other things we are already doing.",
    "kitten",
    "Janaica A",
    "long"
  ],
  [
    "Still giving our shy kitten time",
    "Our six-month-old tortoiseshell, Sassy, is still cautious around visitors. Setting up VelaHush was easy, but the change has been more gradual than I expected. She comes out for meals and sometimes sits in the doorway, then heads back to her quiet spot. We are keeping her routine consistent and giving it more time before deciding how much it helps.",
    "hiding",
    "Violet A",
    "long"
  ],
  [
    "Clear refill guidance",
    "I appreciate knowing each refill lasts about thirty days. It makes planning much easier.",
    "spraying",
    "Mark T",
    "short"
  ],
  [
    "A simple addition to our room routine",
    "We tried VelaHush after changes at home disrupted our cats’ normal routine. We also cleaned previously marked areas and made sure each cat had access to a separate litter box. The diffuser is simple to leave in place, and we have found the room easier to manage as the cats settle back in. We will continue with the same care routine.",
    "spraying",
    "Debbie V",
    "long"
  ],
  [
    "A tidy little setup",
    "The diffuser sits upright in our wall outlet without getting in the way. Setup took very little effort.",
    "spraying",
    "Helen P",
    "short"
  ],
  [
    "Small steps for our shy cat",
    "Our shy cat is spending a little more time near us. We are happy to let her set the pace.",
    "hiding",
    "Sophie W",
    "short"
  ],
  [
    "Convenient to keep using each day",
    "I wanted something that would fit into our cat-care routine without adding a scent to the room. The VelaHush diffuser was straightforward to assemble, and replacing the refill looks simple too. We keep it upright in an open wall outlet near the room our cats use most. I appreciate having clear guidance on placement and the refill schedule.",
    "spraying",
    "Juleanne J",
    "long"
  ],
  [
    "Fits our usual routine",
    "No complicated daily steps. We added it alongside separate feeding areas and our usual playtime.",
    "kitten",
    "Chris N",
    "short"
  ],
  [
    "Easy setup, but little change so far",
    "The kit arrived with everything needed, and setting it up was simple. After using it in our shy cat’s room, I have not noticed much change in how often she hides when people visit. She still prefers her usual quiet corner. The product is convenient to use, but the results so far have not met my expectations.",
    "hiding",
    "Kathleen M",
    "long"
  ],
  [
    "Sharing the sofa at their own pace",
    "Our older cat usually keeps her distance from the younger one. We added VelaHush to the living room and continued giving both cats their own beds and feeding areas. Recently they have been choosing opposite ends of the same sofa instead of staying in separate rooms. They are not best friends overnight, but those little moments have been encouraging.",
    "kitten",
    "Audrey G",
    "long"
  ],
  [
    "A gradual adjustment",
    "The changes have been subtle so far. Easy to use, but I am still giving it more time.",
    "hiding",
    "Laura H",
    "short"
  ],
  [
    "One small step out of hiding",
    "Olive tends to hide under the bed when anything changes at home. We kept her meals and playtime predictable and added VelaHush to the room she spends most time in. By the third week, she was coming out for dinner and staying nearby for a few minutes afterward. We are pleased with those small steps and are letting her set the pace.",
    "hiding",
    "Olive",
    "long"
  ],
  [
    "Happy with the instructions",
    "Clear instructions, simple placement, and an easy refill routine. Exactly the kind of setup I wanted.",
    "spraying",
    "Ben C",
    "short"
  ],
  [
    "A little more shared space",
    "Both cats now choose the living room more often. They still have their own favorite corners.",
    "kitten",
    "Megan S",
    "short"
  ],
  [
    "Clear instructions and a tidy setup",
    "I placed the diffuser near Luna’s favorite room using an uncovered wall outlet. The instructions helped me understand how to keep the unit upright and when to plan a refill. I like that the kit does not add a fragrance to the space. It has been a straightforward part of our daily routine, alongside keeping her litter area clean and familiar.",
    "spraying",
    "Luna",
    "long"
  ]
];
      const ratings=[...Array(20).fill(2),...Array(40).fill(3),...Array(260).fill(4),...Array(1680).fill(5)];
      let seed=48;for(let i=ratings.length-1;i>0;i--){seed=(Math.imul(seed,1664525)+1013904223)>>>0;const j=seed%(i+1);[ratings[i],ratings[j]]=[ratings[j],ratings[i]];}
      [5,4,5,3,5,5,2,5,5].forEach((r,i)=>{const j=ratings.findIndex((x,k)=>k>=i&&x===r);[ratings[i],ratings[j]]=[ratings[j],ratings[i]];});
      const data=ratings.map((rating,i)=>({id:i,rating,snippet:snippets[i%snippets.length],photo:i%4===1}));
      const images=JSON.parse(root.querySelector('[data-sample-images]').textContent),grid=root.querySelector('[data-sample-grid]'),search=root.querySelector('[data-sample-search]'),sort=root.querySelector('[data-sample-sort]'),rating=root.querySelector('[data-sample-rating]'),photos=root.querySelector('[data-sample-photos]'),more=root.querySelector('[data-sample-more]');
      let topic='',limit=9;
      const element=(tag,cls,text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text)e.textContent=text;return e;};
      function render(reset=false){
        if(reset)limit=9;const q=search.value.trim().toLowerCase();
        const matches=data.filter(r=>(!topic||r.snippet[2]===topic)&&(!rating.value||String(r.rating)===rating.value)&&(!photos.checked||r.photo)&&(!q||r.snippet.join(' ').toLowerCase().includes(q)));
        matches.sort((a,b)=>sort.value==='highest'?b.rating-a.rating:sort.value==='lowest'?a.rating-b.rating:sort.value==='oldest'?b.id-a.id:a.id-b.id);
        const frag=document.createDocumentFragment();
        matches.slice(0,limit).forEach(r=>{
          const card=element('article','avp-customer-review');card.dataset.sampleId=String(r.id);card.dataset.copyLength=r.snippet[4];
          if(r.photo){const wrap=element('div','avp-review-photo'),img=element('img');img.src=images[Math.floor(r.id/4)%images.length];img.alt='Person holding VelaHush Cat Calming with a cat';img.loading='lazy';img.width=600;img.height=600;wrap.append(img);card.append(wrap);}
          card.append(element('h3','',r.snippet[0]),element('p','avp-review-body',r.snippet[1]));
          const stars=element('span','avp-review-card-stars','★'.repeat(r.rating)+'☆'.repeat(5-r.rating));stars.setAttribute('aria-label',r.rating+' out of 5');card.append(stars);
          const footer=element('footer');footer.append(element('span','avp-review-avatar',r.snippet[3][0]),element('strong','',r.snippet[3]));card.append(footer);frag.append(card);
        });
        grid.replaceChildren(frag);root.querySelector('[data-sample-count]').textContent='Showing '+Math.min(limit,matches.length)+' of '+matches.length.toLocaleString('en-US')+' reviews';root.querySelector('[data-sample-empty]').hidden=matches.length>0;more.hidden=matches.length<=limit;
      }
      search.addEventListener('input',()=>render(true));[sort,rating,photos].forEach(c=>c.addEventListener('change',()=>render(true)));more.addEventListener('click',()=>{limit+=9;render();});
      root.querySelectorAll('[data-sample-topic]').forEach(b=>b.addEventListener('click',()=>{topic=b.dataset.sampleTopic;root.querySelectorAll('[data-sample-topic]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));render(true);}));
      root.querySelectorAll('[data-sample-photo]').forEach(b=>b.addEventListener('click',()=>{photos.checked=true;render(true);root.querySelector('.avp-reviews-filters').scrollIntoView({behavior:'smooth',block:'start'});}));
      render();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
